import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Icon,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import LoginForm from "../../Auth/login/LoginForm";
const Header = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <Button
        className={className}
        top={{ base: "12.4vh", md: "9.4vh" }}
        style={{ ...style, left: "0", left: "50px" }}
        _before={{ opacity: "0", display: "none" }}
        onClick={onClick}
        bg="#f7d723 !important"
        display={{ base: "none !important", lg: "flex !important" }}
        alignItems="center"
        w="fit-content !important"
        justifyContent={"center"}
        fontSize="27px"
        p="0"
        h="27px"
        _hover={{ opacity: "0.5" }}
      >
        <Icon as={RiArrowRightSLine} color="main_1" />
      </Button>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <Button
        className={className}
        top={{ base: "47vh", md: "45vh" }}
        style={{ ...style, left: "0" }}
        _before={{ opacity: "0", display: "none" }}
        onClick={onClick}
        bg="#f7d723 !important"
        display={{ base: "none !important", lg: "flex !important" }}
        alignItems="center"
        w="fit-content !important"
        justifyContent={"center"}
        fontSize="27px"
        p="0"
        h="27px"
        _hover={{ opacity: "0.5" }}
      >
        <Icon as={RiArrowLeftSLine} color="main_1" />
      </Button>
    );
  }

  return (
    <Flex justifyContent="space-between" bg="main_1" color="white" id="home">
      <Container maxW={"container.xl"}>
        <Flex
          alignItems={"center"}
          justifyContent="space-between"
          bg="main_1"
          color="white"
          pt={95}
          pb={10}
        >
          <Flex flexDirection="column">
            <Heading textTransform={"capitalize"}>
              studying never been easier
            </Heading>

            <Text mt="10px" textTransform={"capitalize"}>
              Discover more study resources through
            </Text>
            <Text textTransform={"capitalize"}>our unique platform</Text>
          </Flex>

          <Box
            position="relative"
            display={{ base: "none", lg: "block" }}
            className="header"
            bg="white"
            shadow="lg"
            padding={5}
            w="40%"
            borderRadius="16px"
            mt={30}
          >
            <LoginForm />
          </Box>
        </Flex>
      </Container>
    </Flex>
  );
};

export default Header;
